import { ScreenSizer } from '@react-three/drei'
import { GroupProps } from '@react-three/fiber'
import { forwardRef, useImperativeHandle, useRef } from 'react'
import { type Group, type Object3D, Shape } from 'three'
import type { Line2 } from 'three/addons/lines/Line2.js'
import { SnapLine } from '~/components/DrawingCanvas/util/SnapLine'
import theme from '~/config/theme'

const cross = new Shape()
cross.moveTo(0, 1)
cross.lineTo(4, 5)
cross.lineTo(5, 4)
cross.lineTo(1, 0)
cross.lineTo(5, -4)
cross.lineTo(4, -5)
cross.lineTo(0, -1)
cross.lineTo(-4, -5)
cross.lineTo(-5, -4)
cross.lineTo(-1, 0)
cross.lineTo(-5, 4)
cross.lineTo(-4, 5)

export type ObstructionsSnaplinesRef = {
  setPositions: (positions: number[]) => void
  show: () => void
  hide: () => void
}

export const ObstructionSnaplines = forwardRef<ObstructionsSnaplinesRef, GroupProps>((props, ref) => {
  const lineRef = useRef<Line2>(null!)
  const start = useRef<Object3D>(null!)
  const end = useRef<Object3D>(null!)
  const groupRef = useRef<Group>(null!)

  useImperativeHandle(
    ref,
    () => ({
      setPositions(positions) {
        lineRef.current.geometry.setPositions(positions)
        start.current.position.set(positions[0], positions[1], positions[2])
        end.current.position.set(positions[3], positions[4], positions[5])
      },
      show() {
        groupRef.current.visible = true
      },
      hide() {
        groupRef.current.visible = false
      },
    }),
    []
  )

  return (
    <group visible={false} {...props} ref={groupRef}>
      <ScreenSizer ref={start}>
        <mesh>
          <shapeGeometry args={[cross]} />
          <meshBasicMaterial color={theme.colors.three.objects.snapRegion.default} />
        </mesh>
      </ScreenSizer>
      <ScreenSizer ref={end}>
        <mesh>
          <shapeGeometry args={[cross]} />
          <meshBasicMaterial color={theme.colors.three.objects.snapRegion.default} />
        </mesh>
      </ScreenSizer>
      <SnapLine lineWidth={2} ref={lineRef} />
    </group>
  )
})
